export default __webpack_public_path__ + "alberta-wound-location.a726afac7f403b84648a.svg";